__turbopack_context__.v({
  "content": "styles-module__h4g3Vq__content",
  "description": "styles-module__h4g3Vq__description",
  "name": "styles-module__h4g3Vq__name",
  "profile": "styles-module__h4g3Vq__profile",
  "profileInfo": "styles-module__h4g3Vq__profileInfo",
  "profilePicture": "styles-module__h4g3Vq__profilePicture",
  "right": "styles-module__h4g3Vq__right",
  "role": "styles-module__h4g3Vq__role",
  "separator": "styles-module__h4g3Vq__separator",
  "talent": "styles-module__h4g3Vq__talent",
});
